import { render, staticRenderFns } from "./VerificationAgreementFreezer.vue?vue&type=template&id=282e8425&"
import script from "./VerificationAgreementFreezer.vue?vue&type=script&lang=js&"
export * from "./VerificationAgreementFreezer.vue?vue&type=script&lang=js&"
import style0 from "./VerificationAgreementFreezer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports